export default __webpack_public_path__ + "static/media/logo_nuovo.c98bbf9e.png";